import { render, staticRenderFns } from "./magazine_publication_tab.vue?vue&type=template&id=682d0f36"
import script from "./magazine_publication_tab.vue?vue&type=script&lang=js"
export * from "./magazine_publication_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports